export const setSystemConfiguration = (state, payload) => (
  {
    ...state,
    systemConfiguration: {
      ...state.systemConfiguration,
      ...payload
    }
  }
)
